document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('section.video.js-video-section[data-type="inline"]');
  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

  function pickVideo(section) {
    const mobile = section.querySelector('video.video__player--mobile.js-video');
    const desktop = section.querySelector('video.video__player.js-video:not(.video__player--mobile)');
    return isMobile() ? (mobile || desktop) : (desktop || mobile);
  }

  function prepareVideo(v) {
    // Autoplay consentito solo se muted
    v.muted = true;
    v.setAttribute('muted', '');
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.autoplay = true;
    v.setAttribute('autoplay', '');
    v.loop = true;
    v.setAttribute('loop', '');

    // fondamentale: se resta preload="none" spesso non vedi nulla
    v.preload = 'auto';
    v.setAttribute('preload', 'auto');

    // se vuoi lasciare i controlli, commenta le 2 righe sotto
    v.controls = false;
    v.removeAttribute('controls');

    try { v.load(); } catch (e) {}
  }

  function makePreviewFrame(section, v) {
    // prova a “portare” un frame senza far partire audio (muted)
    const onMeta = () => {
      try { v.currentTime = 0.01; } catch (e) {}
    };
    const onSeeked = () => {
      section.classList.add('mb-video-preview'); // nasconde placeholder, lascia play se autoplay fallisce
      v.removeEventListener('seeked', onSeeked);
    };

    v.addEventListener('loadedmetadata', onMeta, { once: true });
    v.addEventListener('seeked', onSeeked);
  }

  function tryPlay(section, v) {
    const onPlaying = () => {
      section.classList.add('mb-video-preview', 'mb-video-playing'); // nasconde anche il bottone play
      v.removeEventListener('playing', onPlaying);
    };
    v.addEventListener('playing', onPlaying);

    const p = v.play();
    if (p && typeof p.catch === 'function') p.catch(() => {});
  }

  sections.forEach((section) => {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;

        const v = pickVideo(section);
        if (!v) return;

        prepareVideo(v);
        makePreviewFrame(section, v);
        tryPlay(section, v);

        // retry leggero: il tema può “pausare” subito dopo il load
        setTimeout(() => tryPlay(section, v), 300);
        setTimeout(() => tryPlay(section, v), 1000);
      });
    }, { threshold: 0.25 });

    io.observe(section);
  });
});
